<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.printer_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.printer_form.add_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.printer_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>

        <form>
          <div class="form-row">
            <div class="select-box col-md-6">
              <v-select
                :items="tags"
                item-text="tag_type.reference"
                item-value="tag_type.id"
                v-model="selectedTag"
                prefix="Tag Type :   "
              ></v-select>
            </div>
            <div class="col-md-6">
                <v-select
                  :items="tagFormats"
                  item-text="tag_format.description"
                  item-value="tag_format.id"
                  v-model="selectedTagFormat"
                  prefix="Tag Format :   "
                ></v-select>
            </div>
          </div>
        <v-card-text>
          <form>

            <div class="form-row" v-for="(item, index) in contentParams" :key="index">

          <v-progress-circular v-if="item.loading" indeterminate style="margin-top: 23px;" color="#FF5800"></v-progress-circular>              
  
          <div class="select-box col-md-2" :disabled="gtins.length < 1">
                <v-combobox
                  :items="gtins"
                  :item-text="`gtin`"
                  :item-value="`gtin`"
                  v-model="item.gtin"
                  hide-details
                  :hide-no-data="!searchGtinInput"
                  :label="$t('lang.admin.purchase_order.gtin')"
                  outlined
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                  }"
                  @update:search-input="getGtins"
                  :search-input.sync="searchGtinInput[index]"
                >
                  <template v-slot:no-data>
                    <v-list-item @click="openAddGtinDialog" v-if="searchGtinInput[index]">
                      <span class="subheading">Create &nbsp;</span>
                      <v-chip label small>{{ searchGtinInput[index] }}</v-chip>
                    </v-list-item>
                  </template>
                </v-combobox>
              </div>
              <div class="select-box col-md-1">
                <v-text-field
                  :label="$t('lang.admin.purchase_order.qty')"
                  outlined
                  hide-details
                  v-model="item.quantity"
                  :error="item.wrong"
                ></v-text-field>
              </div>
              <div class="select-box col-md-1">
                <v-icon
                  x-large
                  class="mt-2"
                  @click="focusInput(index)"
                  >mdi-barcode-scan</v-icon
                >
              </div>
              <div class="select-box col-md-1" v-if="index === contentParams.length - 1">
                <v-icon x-large class="mt-2" @click="addNewContentRow">mdi-plus-circle-outline</v-icon>
              </div>
              <div class="select-box col-md-1" v-if="contentParams.length > 1">
                <v-icon x-large class="mt-2" @click="removeRow(index)">mdi-minus-circle-outline</v-icon>
              </div>
              <div class="select-box col-md-0">
              <input  @focus="item.loading = true" @blur="item.loading = false" class="select-box col-md-1" style="opacity: 0" :ref="'barcodeInput' + index" v-model="item.barcode" @keyup.enter="parse_gs1_128(index)">
               
              </div>
            </div>
          </form>
        </v-card-text>

          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded @click="$router.push({ name: 'PrintersList' })">{{ $t("lang.location_form.btn_cancel") }}</v-btn>
              <bx-btn type="submit" color="primary" @click="submitForm">{{ $t("lang.admin.printer_form.btn_done")}}</bx-btn>
            </div>
          </div>
        </form>
       <AddGTINDialog ref="addGtinDialogRef" @close="dialog = true" />
      </div>
    </div>
  </div>
</template>

<script>
import AddGTINDialog from "../../components/AddGTINDialog.vue";

export default {
  name: "GeneratePrinterOrderManual",
  components: {
    AddGTINDialog,
  },
  data() {
    return {

      barcodeInputs: [""],
      gtin: "",
      tags: [],
      items:[],
      totalQuantity: 0,
      contentParams: [{ quantity: null, gtin: null,barcode:null, loading:false, wrong:false }],
      gtins: [],
      searchGtinInput: [],
      tagFormats: [],
      selectedTagFormat: null,
      file: null,
      selectedPrinter: null,
      selectedTag: null,
      errors: [],
      success: {
        show: false,
        message: this.$t("lang.admin.printer_form.success_add_printer_order")
      },
      errorLabels: {
        failed: this.$t("lang.messages.label_something_went_wrong")
      }
    };
  },
  async mounted() {
    this.user = await this.$api.printer.printer_user(
      this.$store.state.user.user
    );
    this.tags = await this.$api.printer.printer_tagtype();
    this.tagFormats = await this.$api.printer.printer_tagtype({tag_type: this.selectedTag});
    
  },
  methods: {
    async focusInput(index) {
      this.barcode = "";
      this.barcodeInputs[index] = "";

      // Focus on the specific combobox
      if (this.$refs.gtinCombobox && this.$refs.gtinCombobox[index]) {
        this.$refs.gtinCombobox[index].$refs.input.focus();
      }
    },
    async addNewContentRow() {
      this.contentParams.push({ quantity: null, gtin: null, loading:false, wrong:false });
      this.barcodeInputs.push("");
    },
    async removeRow(index) {
      this.contentParams.splice(index, 1);
    },
    openAddGtinDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$refs.addGtinDialogRef.open();
        this.searchGtinInput = [];
      }, 0);
    },
    async submitForm() {
      this.items=[]
      this.totalQuantity=0
      this.success.show = false;
      try {
        for (let i = 0; i < this.contentParams.length; i++) {
          try {
            if (this.contentParams[i].gtin.gtin === undefined) {
              await this.$api.types.getV1(this.contentParams[i].gtin)
              this.items.push({"gtin": this.contentParams[i].gtin, "theorical_quantity":this.contentParams[i].quantity});
              this.totalQuantity+=Number(this.contentParams[i].quantity);
            } else {  // in case they click on the autocompleted gtin
              await this.$api.types.getV1(this.contentParams[i].gtin.gtin)
              this.items.push({"gtin": this.contentParams[i].gtin.gtin, "theorical_quantity":this.contentParams[i].quantity});
              this.totalQuantity+=Number(this.contentParams[i].quantity);
            }

          } catch (error) {
            if (error.response && error.response.status >= 400) {
            this.errors.push("No se ha podido crear la orden. Uno de los artículos no existe.");
          }
            console.log(error)
            this.contentParams[i].wrong=true
            return;
          }
        }
        this.companyFormat = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag,
          tag_format: this.selectedTagFormat,
          limit: 10
        }); 
        const res = await this.$api.printer.set_print_order({
            companyformat_id: this.companyFormat.results[0].id,
            responsible_id: this.user.company,
            total_quantity: this.totalQuantity,
            items: this.items
        });
        this.success.show = true;
        console.log(res)
      } catch (error) {
          if (error.response && error.response.status >= 400) {
            this.errors.push("No se ha podido crear la orden. Comunique que algo no ha ido bien.");
          }
      }
    },
    async parse_gs1_128(index) {
      var barcode=this.contentParams[index].barcode
      // Buscamos los identificadores de aplicación (AI) y los datos correspondientes
      const gtin_match = barcode.match(/(?<=01)[0-9]{14}/);
      if (gtin_match) {
          this.contentParams[index].gtin = gtin_match[0];
          barcode = barcode.slice(gtin_match[0].length);
      }

      this.contentParams[index].barcode=""
      // await this.focusInput(index+1)
    },
    async getGtins(value) {
      if (value && value.length >= 9) {
          this.loadingGtin = true;
          this.gtins = await this.$api.location.salesGtins({
            gtin__contains: value,
          });
          this.loadingGtin = false;
        }
      },
    }
};
</script>

